/* eslint-disable no-script-url */
import MicroModal from 'micromodal';
import micromodalOptions from '../lib/micromodal-options.js';

class PrimaryAction {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }
    this.element = element;

    this.initialAction = () => {
      console.warn('No action initialised');
    };
    this.currentAction = this.initialAction;
    this.initialButtonText = this.element.innerText;
    this.currentButtonText = this.initialButtonText;
    this.isSWW = document.querySelector('.winter-wonderland-page');
    this.buttonEnabled = true;
    this.init();
  }

  initAction() {
    if (document.getElementById('modal-booking-form')) {
      return () => {
        MicroModal.show('modal-booking-form', micromodalOptions);
      };
    }

    // not the most elegant solution but other solutions would require the HTML being modified
    const scrollableElement = document.querySelector(`
      #basket .overview,
      .voucher-form .overview,
      .section--day-tickets
    `);

    if (scrollableElement) {
      return () => {
        scrollableElement.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      };
    }

    if (this.element.href === 'javascript:void(0);') {
      return () => {
        MicroModal.show('modal-activity-selector', micromodalOptions);
      };
    }

    return () => {
      window.location.href = this.element.href;
    };
  }

  updateButton() {
    this.element.innerText = this.currentButtonText;
    if (this.buttonEnabled) {
      this.element.classList.remove('btn--disabled');
    } else {
      this.element.classList.add('btn--disabled');
    }
  }

  init() {
    this.initialAction = this.initAction();
    this.currentAction = this.initialAction;

    if (this.isSWW) {
      window.addEventListener('primary.action.override', (e) => {
        // The booking widget lives in a modal and has its own submit button, so
        // Book Now must always stay an "open the modal" action.
        if (document.getElementById('modal-booking-form')) {
          return;
        }

        this.currentButtonText = e.detail.buttonText;
        this.currentAction = e.detail.buttonAction;
        this.buttonEnabled = e.detail.buttonEnabled;
        this.updateButton();
      });

      window.addEventListener('primary.action.reset', (e) => {
        this.currentButtonText = this.initialButtonText;
        this.currentAction = this.initialAction;
        this.buttonEnabled = true;
        this.updateButton();
      });
    }

    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.currentAction();
    });
  }
}

export default PrimaryAction;
